import axios from 'axios'

export const getRate = (id) => {
  return axios.get(`rate/shipment/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getRateDetail = (id) => {
  return axios.get(`rate/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const postRate = (payload) => {
  return axios.post('rate', payload)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const getDashboardRate = () => {
  return axios.get('rate/front')
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}

export const putSkipRate = (id) => {
  return axios.put(`rate/skip/${id}`)
    .then(res => res)
    .catch(err => {
      console.log('err', err, err.response)
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/rate.api.js